<!-- The basis of this system is derived from here: https://github.com/vycoder/vue-markdown-blog -->

<template>
  <div>
    <b-container>
    <br/>
    
    <MainSection
      title="All-Systems Electronics Blog"
      textSide="left"
      imagePath=""
      >
        <b-container>
          <div v-for="entry in entries.entries" :key="entry.id">
            <b-row>
            <b-col lg="9" cols="10">
              <h4><router-link :to="{ name: entry.id }">{{entry.title}}</router-link></h4>
            </b-col>
            <b-col lg="3" cols="10">
              <h5>{{entry.date}}</h5>
            </b-col>
            </b-row>
            <b-row>
            <b-col lg="9" cols="10">
              <p>{{entry.description}}</p>
            </b-col>
            </b-row>
          </div>
        </b-container>
    </MainSection>

    <br/>
    </b-container>

  </div>
</template>

<script>
import BLOGENTRIES from '@/blog/entries.json';
import MainSection from './MainSection.vue';

export default {
  name: 'Blog',
  computed: {
    entries() {
      return BLOGENTRIES
    }
  },
  components: {
    MainSection
  },
}
</script>
